// extracted by mini-css-extract-plugin
export default {"wrapper":"IB-z","button":"JB-z","alternate":"KB-z","disabled":"LB-z","paymentWarning":"MB-z","fadeIn":"NB-z"};